import { create } from 'zustand';
import { IDam } from '../interfaces/IUser';

interface DamStoreState {
  dams: IDam[];
  loading: boolean;
  error: string | null;
  setDams: (dams: IDam[]) => void;
  addDam: (dam: IDam) => void;
  updateDam: (id: string, dam: Partial<IDam>) => void;
  removeDam: (id: string) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useDamStore = create<DamStoreState>((set) => ({
  dams: [],
  loading: false,
  error: null,
  setDams: (dams) => set({ dams }),
  addDam: (dam) => set((state) => ({ dams: [...state.dams, dam] })),
  updateDam: (id, updatedDam) =>
    set((state) => ({
      dams: state.dams.map((d) => (d.id === id ? { ...d, ...updatedDam } : d)),
    })),
  removeDam: (id) =>
    set((state) => ({
      dams: state.dams.filter((d) => d.id !== id),
    })),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
}));
